// import CountUp from "react-countup";
// import Tip from "../../core/common/tooltip";

// interface KpiCardProps {
//   title: string;
//   value: number;
//   icon: string;
//   color?: string;
//   suffix?: string;
//   subtitle?: string;
//   tooltip?: string;
//   style?: React.CSSProperties;
// }

// const KpiCard: React.FC<KpiCardProps> = ({
//   title,
//   value,
//   icon,
//   color = "primary",
//   suffix = "",
//   subtitle,
//   tooltip,
//   style
// }) => {
//   return (
//     <div className="card shadow-sm h-100 dashboard-card" style={style}>
//       <div className="card-body d-flex align-items-center justify-content-between">
//         <div>
//           <div className="d-flex align-items-center gap-1 mb-1">
//             <h6 className="text-muted mb-0">{title}</h6>
//             {tooltip && (
//               <Tip text={tooltip}>
//                 <i
//                   className="fa fa-info-circle text-primary"
//                   style={{ cursor: "pointer", fontSize: "14px" }}
//                 />
//               </Tip>
//             )}

//           </div>

//           <h3 className={`fw-bold text-${color} mb-0`}>
//             <CountUp end={value} duration={1.2} separator="," preserveValue />
//             {suffix}
//           </h3>

//           {subtitle && (
//             <small className="text-muted">{subtitle}</small>
//           )}
//         </div>

//         <div className={`kpi-icon bg-${color}-soft text-${color}`}>
//           <i className={`ti ${icon}`} />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default KpiCard;
import CountUp from "react-countup";
import Tip from "../../core/common/tooltip";

interface KpiCardProps {
  title: string;
  title1?: string;
  value: number;
  icon: string;
  color?: string;
  suffix?: string;
  subtitle?: string;
  tooltip?: string;
  style?: React.CSSProperties;
  percentage?: string; // ← NEW
  percentageColor?: "success" | "danger" | "warning" | "info" | "primary"; // ← NEW
  percentageIcon?: string; // ← NEW
}

const KpiCard: React.FC<KpiCardProps> = ({
  title,
  title1,
  value,
  icon,
  color = "primary",
  suffix = "",
  subtitle,
  tooltip,
  style,
  percentage,
  percentageColor = "success",
  percentageIcon,
}) => {
  return (
    <div className="card shadow-sm h-100 dashboard-card kpi-card" style={style}>
      <div className="card-body d-flex align-items-center justify-content-between">
        {/* LEFT CONTENT */}
        <div>
          <div className="d-flex align-items-start gap-1 mb-1">
            <h6 className="text-muted mb-0 fw-semibold">{title}</h6>

            {tooltip && (
              <Tip text={tooltip}>
                <i
                  className="fa fa-info-circle text-secondary ms-1"
                  style={{ cursor: "pointer", fontSize: "13px", marginTop:"3px" }}
                />
              </Tip>
            )}
          </div>
          <h6 className="text-muted mb-0 fw-semibold">{title1}</h6>
          <h3 className={`fw-bold text-${color} mb-0`}>
            <CountUp end={value} duration={1.3} separator="," preserveValue />
            {suffix}
          </h3>

          {subtitle && (
            <small className="text-muted d-block mt-1">{subtitle}</small>
          )}

          {/* Reserve space for percentage line on ALL cards */}
          <div className="d-flex align-items-center gap-1 mt-2 min-h-20">
            {" "}
            {/* min-h-20 = min-height: 20px */}
            {percentage !== undefined ? (
              <span className={`text-${percentageColor} fw-semibold small`}>
                {percentageIcon && <i className={`${percentageIcon} me-1`} />}
                {Math.abs(parseFloat(percentage))}%
              </span>
            ) : (
              <span className="text-transparent small">All Time</span>
            )}
            {percentage !== undefined && (
              <span className="text-muted small">vs last month</span>
            )}
          </div>
        </div>

        {/* RIGHT ICON */}
        <div className={`kpi-icon bg-${color}`}>
          <i className={`${icon} text-white`} />
        </div>
      </div>
    </div>
  );
};

export default KpiCard;
